{
  "districtName": "District Name",
  "districtLogoAlsoAddLater": "District Logo (you can also add this later)",
  "districts": "Districts",
  "createDistrict": "Create District",
  "myDistrict": "My District",
  "updateDetailsDistrict": "Update the details for your district.",
  "districtUpdated": "District updated",
  "districtCreated": "District created",
  "districtAddress": "District Address",
  "searchByDistrictName": "Search by district name",
  "letSStartByCreating": "Let’s start by creating the district that Campus Guardian Angel will be protecting.",
  "addDistrict": "Add District",
  "svgPngJpgOrGif": "SVG, PNG, JPG or GIF (max. 800x400px)"
}
